import React, { useState, useEffect, useMemo } from "react";
import { Button, Box, Typography, Grid, TextField, Autocomplete, FormHelperText } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useAddProcurementDpItemsMutation } from "store/slices/apis/procurementDpItemsSlice";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";
import { useGetAllContactsQuery } from "store/slices/apis/contactSlice";
import { usePermission } from "hooks/usePermission";
import Select from "react-select";

const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>

);
const DpItems = (props) => {
    const { tabKey, handleClose, onSubmit, actionSubProjects } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const [actionResponsible, setActionContact] = useState([])
    const isAdminAccess = usePermission()

    const module = "Procurement"


    const [createProcurementDpItems] = useAddProcurementDpItemsMutation();

    const { data: materialCategoryData } = useGetMasterDataQuery({ module: module, category: 'MaterialCategory', ProjectId: projectId });
    const { data: uomData } = useGetMasterDataQuery({ module: module, category: 'UOM', ProjectId: projectId });
    const { data: procurementMethodData } = useGetMasterDataQuery({ module: module, category: 'ProcurementMethod', ProjectId: projectId });
    const { data: SourceDepartmentData } = useGetMasterDataQuery({ module: module, category: 'SourceDepartment', ProjectId: projectId });
    const { data: MaterialProcurementStatusData } = useGetMasterDataQuery({ module: module, category: 'MaterialProcurementStatus', ProjectId: projectId });

    const materialProcurementStatusOption = MaterialProcurementStatusData?.data.map((item) => ({
        label: item?.value,
        value: item?.value
    })
    )
    const contactListRes = useGetAllContactsQuery();
    const { data: vendorNameList } = useGetMasterDataQuery({ module: module, category: 'VendorName', ProjectId: projectId });
    const vendorNameOption = useMemo(() => {
        return vendorNameList?.data
            ?.map((item) => ({
                label: item?.value,
                value: item?.value
            }))
            ?.sort((a, b) => a?.label?.localeCompare(b?.label)) || [];
    }, [vendorNameList]);

    const { data: procurementStatusRes } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: projectId });
    const procurementStatusData = procurementStatusRes?.data || [];
    const procurementStatusOption = (procurementStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: procurementAdminStatusRes } = useGetMasterDataQuery({ module: module, category: 'AdminStatus', ProjectId: projectId });
    const procurementAdminStatusData = procurementAdminStatusRes?.data || [];
    const procurementAdminStatusOption = (procurementAdminStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const filteredStatusOption = isAdminAccess
        ? procurementAdminStatusOption
        : procurementStatusOption;

    useEffect(() => {
        if (contactListRes?.isSuccess) {
            const contacts = contactListRes?.data?.data || [];
            setActionContact(
                mapAndSortAlphabetically(contacts, "name", "email")
            );
            // setActionContact(
            //     contactListRes?.data?.data?.map(item => ({
            //         value: item?.email,
            //         label: item?.name
            //     }))
            // );
        }
    }, [contactListRes])


    const materialCategoryOption = materialCategoryData?.data.map((item) => ({
        label: item?.value,
        value: item?.value
    })
    )

    const uomOption = uomData?.data.map((item) => ({
        label: item?.value,
        value: item?.value
    })
    )

    const procurementMethodOption = procurementMethodData?.data.map((item) => ({
        label: item?.value,
        value: item?.value
    })
    )

    const SourceDepartmentOption = SourceDepartmentData?.data.map((item) => ({
        label: item?.value,
        value: item?.value
    })
    )




    const [formData, setFormData] = useState({
        requisitionDate: "",
        materialDescription: "",
        uom: "",
        subProject: "",
        quantityRequired: null,
        processTime: null,
        leadTime: null,
        plannedLoiWoPoReleaseDate: "",
        vendorName: "",
        poDate: "",
        poNumber: "",
        poQuantity: null,
        poRate: null,
        poValue: null,
        plannedDeliveryDate: "",
        materialCategory: "",
        remarks: "",
        actualCost: null,
        budgetedCost: null,
        budgetedUnitRate: null,
        actualUnitRate: null,
        deliveredQty: null,
        pendingQty: null,
        deliveryVariance: "",
        materialProcureMentStatus: "",
        actualDeliveryDate: "",
        status: "",
        procurementMethod: "",
        sourceDepartment: "",
        procurementOwner: "",
        plannedDateOfTenderPackage: ""
    });


    const validationSchema = Yup.object({

        // requisitionDate: Yup.date().required("Requisition Date is required"),
        // uom: Yup.string().required("UOM is required"),
        // quantityRequired: Yup.number().typeError("Quantity Required must be a number").positive("Quantity Required must be greater than 0").required("Quantity Required is required"),
        // processTime: Yup.number().typeError("Process Time must be a number").min(0, "Process Time cannot be negative").required("Process Time is required"),
        // leadTime: Yup.number().typeError("Lead Time must be a number").min(0, "Lead Time cannot be negative").required("Lead Time is required"),
        // plannedDate: Yup.date().required("Planned Date is required"),
        // vendorName: Yup.string().required("Vendor Name is required"),
        // poDate: Yup.date().required("PO Date is required"),
        // poNumber: Yup.string().required("PO Number is required"),
        // poQuantity: Yup.number().typeError("PO Quantity must be a number").required("PO Quantity is required"),
        // poRate: Yup.number().typeError("PO Rate must be a number").required("PO Rate is required"),
        // poValue: Yup.number().typeError("PO Value must be a number").required("PO Value is required"),
        // plannedDeliveryDate: Yup.date().required("Planned Delivery Date is required"),
        materialDescription: Yup.string().trim().required("Material Description is required"),
        status: Yup.string().trim().required("Status is required"),


    });


    const handleDpItemsSubmit = async (values, { setSubmitting, resetForm }) => {


        const formatDate = (dateString) => {
            if (!dateString) return null;
            return moment(dateString).format('YYYY-MM-DDTHH:mm:ss[Z]');
        };

        const safeParseInt = (value) => {
            if (!value && value !== 0) return 0;
            const num = parseInt(value);
            return isNaN(num) ? 0 : num;
        };

        const safeParseFloat = (value) => {
            if (!value && value !== 0) return 0;
            const num = parseFloat(value);
            return isNaN(num) ? 0 : num;
        };


        let reqBody = {
            slNo: 0,
            srNo: "string",
            customId: "string",
            projectId: projectId,
            projectName: "string",
            subProject: values?.subProject || "",
            procurementType: tabKey || "",
            requisitionDate: formatDate(values.requisitionDate),
            materialDescription: values.materialDescription || "",
            uom: values.uom || "",
            quantityRequired: safeParseInt(values.quantityRequired),
            processTime: safeParseInt(values.processTime),
            leadTimeDays: safeParseInt(values.leadTime),
            plannedLoiWoPoReleaseDate: formatDate(values.plannedLoiWoPoReleaseDate),
            vendorName: values.vendorName || "",
            poDate: formatDate(values.poDate),
            poNumber: values?.poNumber || "",
            poQuantity: safeParseFloat(values.poQuantity),
            poRate: safeParseFloat(values.poRate),
            poValue: safeParseFloat(values.poValue),
            plannedDeliveryDate: formatDate(values.plannedDeliveryDate),
            note: values.remarks || "",
            materialCategory: values?.materialCategory || "",
            actualCost: safeParseFloat(values.actualCost),
            budgetedCost: safeParseFloat(values.budgetedCost),
            budgetedUnitRate: safeParseFloat(values.budgetedUnitRate),
            actualUnitRate: safeParseFloat(values.actualUnitRate),
            deliveredQty: safeParseInt(values.deliveredQty),
            pendingQty: safeParseInt(values.pendingQty),
            deliveryVariance: safeParseInt(values.deliveryVariance),

            materialProcureMentStatus: values?.materialProcureMentStatus || "",
            actualDeliveryDate: formatDate(values.actualDeliveryDate),
            status: values?.status || "",
            procurementMethod: values?.procurementMethod || "",
            sourceDepartment: values?.sourceDepartment || "",
            procurementOwner: values?.procurementOwner || "",
            plannedDateOfTenderPackage: formatDate(values.plannedDateOfTenderPackage)

        };


        try {
            const response = await createProcurementDpItems(reqBody).unwrap();
            openNotification("Procurement created successfully", "success");
            resetForm();
            setSubmitting(false);
            handleClose();
        } catch (error) {
            openNotification(error?.error ?? "Something is wrong", "error");
        } finally {
            setSubmitting(false);
        }

        setSubmitting(false);
    };







    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };



    return (

        <Formik
            initialValues={formData}
            validationSchema={validationSchema}
            onSubmit={handleDpItemsSubmit}
        >
            {({ values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
                setFieldTouched,
                setTouched, }) => (
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Select Sub Project
                            </Typography>
                            <Select
                                name="subProject"
                                options={actionSubProjects}
                                value={actionSubProjects.find(opt => opt.value === values.subProject) || null}
                                onChange={(option) => setFieldValue("subProject", option.value)}
                                onBlur={() => setFieldTouched("subProject", true)}
                                placeholder="Select Sub Project"
                            />
                            {touched.subProject && errors.subProject && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                    {errors.subProject}
                                </Typography>
                            )}
                        </Grid>
                        {/* <Grid size={{ xs: 12, md: 12 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Sub Project
                            </Typography>
                            <TextField
                                fullWidth
                                name="subProject"
                                value={values.subProject}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Sub Project"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                            {touched?.subProject && errors?.subProject && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors?.subProject}
                                </Typography>
                            )}
                        </Grid> */}


                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Planned Date of Tender Package
                            </Typography>
                            <TextField
                                type="date"
                                name="plannedDateOfTenderPackage"
                                value={values.plannedDateOfTenderPackage}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onClick={(e) => {
                                    // Trigger the native date picker
                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                    if (input) input.showPicker?.();
                                }}
                                fullWidth
                                sx={{
                                    ...rightTextStyle,
                                    "& input::-webkit-calendar-picker-indicator": {
                                        display: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& input[type='date']": {
                                        appearance: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            border: "none",
                                        },
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                        >
                                            {calenderSVG}
                                        </Box>
                                    ),
                                    sx: {
                                        backgroundColor: "#fff",
                                        border: '1px solid',
                                        borderColor: 'hsl(0, 0%, 80%)',
                                        height: "40px",
                                        width: { xs: "100%", md: "100%" },
                                        borderRadius: "5px",
                                    },
                                }}
                            />
                            {touched.plannedDateOfTenderPackage && errors.plannedDateOfTenderPackage && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors.plannedDateOfTenderPackage}
                                </Typography>
                            )}
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Requisition Date
                            </Typography>
                            <TextField
                                type="date"
                                name="requisitionDate"
                                value={values.requisitionDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onClick={(e) => {
                                    // Trigger the native date picker
                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                    if (input) input.showPicker?.();
                                }}
                                fullWidth
                                sx={{
                                    ...rightTextStyle,
                                    "& input::-webkit-calendar-picker-indicator": {
                                        display: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& input[type='date']": {
                                        appearance: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            border: "none",
                                        },
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                        >
                                            {calenderSVG}
                                        </Box>
                                    ),
                                    sx: {
                                        backgroundColor: "#fff",
                                        border: '1px solid',
                                        borderColor: 'hsl(0, 0%, 80%)',
                                        height: "40px",
                                        width: { xs: "100%", md: "100%" },
                                        borderRadius: "5px",
                                    },
                                }}
                            />
                            {touched.requisitionDate && errors.requisitionDate && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors.requisitionDate}
                                </Typography>
                            )}
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Select Material Category
                            </Typography>
                            <Autocomplete
                                options={materialCategoryOption}
                                getOptionLabel={(option) => option?.label || ''}
                                value={
                                    materialCategoryOption?.find(
                                        (opt) => opt.label == values?.materialCategory
                                    ) || null
                                }
                                onChange={(_, newSelected) => {
                                    // const updated = newSelected.map(item => ({ roleId: item?.id }));
                                    setFieldValue(
                                        `materialCategory`,
                                        newSelected ? newSelected.label : ""   // store only roleId string
                                    );
                                }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Material Category"
                                        name={`materialCategory`}
                                        size="small"
                                        sx={{
                                            "& input::placeholder": {
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                letterSpacing: "0.16px",
                                                color: "#5F5F5F",
                                                fontFamily: "Outfit, sans-serif",
                                                opacity: 1,
                                            },
                                        }}
                                    />
                                )}
                                ListboxProps={{ sx: { fontSize: '13px' } }}
                            />
                            {touched?.materialCategory && errors?.materialCategory &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.materialCategory}`}</FormHelperText>
                            }
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Select Procurement Method
                            </Typography>
                            <Autocomplete
                                options={procurementMethodOption}
                                getOptionLabel={(option) => option?.label || ''}
                                value={
                                    procurementMethodOption?.find(
                                        (opt) => opt.label == values?.procurementMethod
                                    ) || null
                                }
                                onChange={(_, newSelected) => {
                                    // const updated = newSelected.map(item => ({ roleId: item?.id }));
                                    setFieldValue(
                                        `procurementMethod`,
                                        newSelected ? newSelected.label : ""   // store only roleId string
                                    );
                                }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Procurement Method"
                                        name={`procurementMethod`}
                                        size="small"
                                        sx={{
                                            "& input::placeholder": {
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                letterSpacing: "0.16px",
                                                color: "#5F5F5F",
                                                fontFamily: "Outfit, sans-serif",
                                                opacity: 1,
                                            },
                                        }}
                                    />
                                )}
                                ListboxProps={{ sx: { fontSize: '13px' } }}
                            />
                            {touched?.procurementMethod && errors?.procurementMethod &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.procurementMethod}`}</FormHelperText>
                            }
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Budgeted Cost (In INR)
                            </Typography>
                            <TextField
                                fullWidth
                                name="budgetedCost"
                                value={values.budgetedCost}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Budgeted Cost"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Actual Cost (In INR)
                            </Typography>
                            <TextField
                                fullWidth
                                name="actualCost"
                                value={values.actualCost}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Actual Cost"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Budgeted Unit Rate (In INR)
                            </Typography>
                            <TextField
                                fullWidth
                                name="budgetedUnitRate"
                                value={values.budgetedUnitRate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Budgeted Unit Rate"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Actual Unit Rate (In INR)
                            </Typography>
                            <TextField
                                fullWidth
                                name="actualUnitRate"
                                value={values.actualUnitRate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Actual Unit Rate"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Planned Date of Release of LOI/WO/PO
                            </Typography>
                            <TextField
                                type="date"
                                name="plannedLoiWoPoReleaseDate"
                                value={values.plannedLoiWoPoReleaseDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onClick={(e) => {
                                    // Trigger the native date picker
                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                    if (input) input.showPicker?.();
                                }}
                                fullWidth
                                sx={{
                                    ...rightTextStyle,
                                    "& input::-webkit-calendar-picker-indicator": {
                                        display: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& input[type='date']": {
                                        appearance: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            border: "none",
                                        },
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                        >
                                            {calenderSVG}
                                        </Box>
                                    ),
                                    sx: {
                                        backgroundColor: "#fff",
                                        border: '1px solid',
                                        borderColor: 'hsl(0, 0%, 80%)',
                                        height: "40px",
                                        width: { xs: "100%", md: "100%" },
                                        borderRadius: "5px",
                                    },
                                }}
                            />
                            {touched.plannedLoiWoPoReleaseDate && errors.plannedLoiWoPoReleaseDate && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors.plannedLoiWoPoReleaseDate}
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Planned Delivery Date
                            </Typography>
                            <TextField
                                type="date"
                                name="plannedDeliveryDate"
                                value={values.plannedDeliveryDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onClick={(e) => {
                                    // Trigger the native date picker
                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                    if (input) input.showPicker?.();
                                }}
                                fullWidth
                                sx={{
                                    ...rightTextStyle,
                                    "& input::-webkit-calendar-picker-indicator": {
                                        display: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& input[type='date']": {
                                        appearance: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            border: "none",
                                        },
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                        >
                                            {calenderSVG}
                                        </Box>
                                    ),
                                    sx: {
                                        backgroundColor: "#fff",
                                        border: '1px solid',
                                        borderColor: 'hsl(0, 0%, 80%)',
                                        height: "40px",
                                        width: { xs: "100%", md: "100%" },
                                        borderRadius: "5px",
                                    },
                                }}
                            />
                            {touched.plannedDeliveryDate && errors.plannedDeliveryDate && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors.plannedDeliveryDate}
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Select Source Department
                            </Typography>
                            <Autocomplete
                                options={SourceDepartmentOption}
                                getOptionLabel={(option) => option?.label || ''}
                                value={
                                    SourceDepartmentOption?.find(
                                        (opt) => opt.label == values?.sourceDepartment
                                    ) || null
                                }
                                onChange={(_, newSelected) => {
                                    // const updated = newSelected.map(item => ({ roleId: item?.id }));
                                    setFieldValue(
                                        `sourceDepartment`,
                                        newSelected ? newSelected.label : ""   // store only roleId string
                                    );
                                }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Source Department"
                                        name={`sourceDepartment`}
                                        size="small"
                                        sx={{
                                            "& input::placeholder": {
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                letterSpacing: "0.16px",
                                                color: "#5F5F5F",
                                                fontFamily: "Outfit, sans-serif",
                                                opacity: 1,
                                            },
                                        }}
                                    />
                                )}
                                ListboxProps={{ sx: { fontSize: '13px' } }}
                            />
                            {touched?.sourceDepartment && errors?.sourceDepartment &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.sourceDepartment}`}</FormHelperText>
                            }
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Select Procurement Owner
                            </Typography>
                            <Autocomplete
                                options={actionResponsible}
                                getOptionLabel={(option) => option?.label || ''}
                                value={
                                    actionResponsible?.find(
                                        (opt) => opt.value == values?.procurementOwner
                                    ) || null
                                }
                                onChange={(_, newSelected) => {
                                    // const updated = newSelected.map(item => ({ roleId: item?.id }));
                                    setFieldValue(
                                        `procurementOwner`,
                                        newSelected ? newSelected.value : ""   // store only roleId string
                                    );
                                }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Procurement Owner"
                                        name={`procurementOwner`}
                                        size="small"
                                        sx={{
                                            "& input::placeholder": {
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                letterSpacing: "0.16px",
                                                color: "#5F5F5F",
                                                fontFamily: "Outfit, sans-serif",
                                                opacity: 1,
                                            },
                                        }}
                                    />
                                )}
                                ListboxProps={{ sx: { fontSize: '13px' } }}
                            />
                            {touched?.procurementOwner && errors?.procurementOwner &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.procurementOwner}`}</FormHelperText>
                            }
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Delivered Qty
                            </Typography>
                            <TextField
                                fullWidth
                                name="deliveredQty"
                                value={values.deliveredQty}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Delivered Qty"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Pending Qty
                            </Typography>
                            <TextField
                                fullWidth
                                name="pendingQty"
                                value={values.pendingQty}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Pending Qty"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Delivery Variance
                            </Typography>
                            <TextField
                                fullWidth
                                name="deliveryVariance"
                                value={values.deliveryVariance}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Delivery Variance"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Select UOM
                            </Typography>
                            <Autocomplete
                                options={uomOption}
                                getOptionLabel={(option) => option?.label || ''}
                                value={
                                    uomOption?.find(
                                        (opt) => opt.label == values?.uom
                                    ) || null
                                }
                                onChange={(_, newSelected) => {
                                    setFieldValue(
                                        `uom`,
                                        newSelected ? newSelected.label : ""
                                    );
                                }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select UOM"
                                        name={`uom`}
                                        size="small"
                                        sx={{
                                            "& input::placeholder": {
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                letterSpacing: "0.16px",
                                                color: "#5F5F5F",
                                                fontFamily: "Outfit, sans-serif",
                                                opacity: 1,
                                            },
                                        }}
                                    />
                                )}
                                ListboxProps={{ sx: { fontSize: '13px' } }}
                            />
                            {touched?.uom && errors?.uom &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.uom}`}</FormHelperText>
                            }
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Quantity Required
                            </Typography>
                            <TextField
                                fullWidth
                                name="quantityRequired"
                                value={values.quantityRequired}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Quantity Required"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                            {touched?.quantityRequired && errors?.quantityRequired && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors?.quantityRequired}
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Actual Delivery Date
                            </Typography>
                            <TextField
                                type="date"
                                name="actualDeliveryDate"
                                value={values.actualDeliveryDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onClick={(e) => {
                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                    if (input) input.showPicker?.();
                                }}
                                fullWidth
                                sx={{
                                    ...rightTextStyle,
                                    "& input::-webkit-calendar-picker-indicator": {
                                        display: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& input[type='date']": {
                                        appearance: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            border: "none",
                                        },
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                            {calenderSVG}
                                        </Box>
                                    ),
                                    sx: {
                                        backgroundColor: "#fff",
                                        border: '1px solid',
                                        borderColor: 'hsl(0, 0%, 80%)',
                                        height: "40px",
                                        width: { xs: "100%", md: "100%" },
                                        borderRadius: "5px",
                                    },
                                }}
                            />
                            {touched.actualDeliveryDate && errors.actualDeliveryDate && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors.actualDeliveryDate}
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Process Time
                            </Typography>
                            <TextField
                                fullWidth
                                name="processTime"
                                value={values.processTime}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Process Time"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                            {touched?.processTime && errors?.processTime && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors?.processTime}
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Lead Time
                            </Typography>
                            <TextField
                                fullWidth
                                name="leadTime"
                                value={values.leadTime}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Lead Time"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                            {touched?.leadTime && errors?.leadTime && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors?.leadTime}
                                </Typography>
                            )}
                        </Grid>
                        {/* <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Planned Date
                            </Typography>
                            <TextField
                                type="date"
                                name="plannedDate"
                                value={values.plannedDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onClick={(e) => {
                                    // Trigger the native date picker
                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                    if (input) input.showPicker?.();
                                }}
                                fullWidth
                                sx={{
                                    ...rightTextStyle,
                                    "& input::-webkit-calendar-picker-indicator": {
                                        display: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& input[type='date']": {
                                        appearance: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            border: "none",
                                        },
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                        >
                                            {calenderSVG}
                                        </Box>
                                    ),
                                    sx: {
                                        backgroundColor: "#fff",
                                        border: '1px solid',
                                        borderColor: 'hsl(0, 0%, 80%)',
                                        height: "40px",
                                        width: { xs: "100%", md: "100%" },
                                        borderRadius: "5px",
                                    },
                                }}
                            />
                            {touched.plannedDate && errors.plannedDate && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors.plannedDate}
                                </Typography>
                            )}
                        </Grid> */}
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Vendor Name
                            </Typography>
                            {/* <TextField
                                fullWidth
                                name="vendorName"
                                value={values.vendorName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Vendor Name"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            /> */}
                            <Autocomplete
                                options={vendorNameOption}
                                getOptionLabel={(option) => option?.label || ''}
                                value={
                                    vendorNameOption?.find(
                                        (opt) => opt.value == values?.vendorName
                                    ) || null
                                }
                                onChange={(_, newSelected) => {
                                    setFieldValue(
                                        `vendorName`,
                                        newSelected ? newSelected.value : ""
                                    );
                                }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Vendor Name"
                                        name={`vendorName`}
                                        size="small"
                                        sx={{
                                            "& input::placeholder": {
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                letterSpacing: "0.16px",
                                                color: "#5F5F5F",
                                                fontFamily: "Outfit, sans-serif",
                                                opacity: 1,
                                            },
                                        }}
                                    />
                                )}
                                ListboxProps={{ sx: { fontSize: '13px' } }}
                            />
                            {touched?.vendorName && errors?.vendorName && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors?.vendorName}
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                PO Date
                            </Typography>
                            <TextField
                                type="date"
                                name="poDate"
                                value={values.poDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onClick={(e) => {
                                    // Trigger the native date picker
                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                    if (input) input.showPicker?.();
                                }}
                                fullWidth
                                sx={{
                                    ...rightTextStyle,
                                    "& input::-webkit-calendar-picker-indicator": {
                                        display: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& input[type='date']": {
                                        appearance: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            border: "none",
                                        },
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                        >
                                            {calenderSVG}
                                        </Box>
                                    ),
                                    sx: {
                                        backgroundColor: "#fff",
                                        border: '1px solid',
                                        borderColor: 'hsl(0, 0%, 80%)',
                                        height: "40px",
                                        width: { xs: "100%", md: "100%" },
                                        borderRadius: "5px",
                                    },
                                }}
                            />
                            {touched.poDate && errors.poDate && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors.poDate}
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                PO Number
                            </Typography>
                            <TextField
                                fullWidth
                                name="poNumber"
                                value={values.poNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter PO Number"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                            {touched?.poNumber && errors?.poNumber && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors?.poNumber}
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                PO Quantity
                            </Typography>
                            <TextField
                                fullWidth
                                name="poQuantity"
                                value={values.poQuantity}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter PO Quantity"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                            {touched?.poQuantity && errors?.poQuantity && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors?.poQuantity}
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                PO Rate
                            </Typography>
                            <TextField
                                fullWidth
                                name="poRate"
                                value={values.poRate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter PO Rate"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                            {touched?.poRate && errors?.poRate && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors?.poRate}
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                PO Value (Cr)
                            </Typography>
                            <TextField
                                fullWidth
                                name="poValue"
                                value={values.poValue}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter PO Value"
                                InputProps={{
                                    sx: {
                                        height: "40px",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#5F5F5F",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            "&:-webkit-autofill": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:hover": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                            "&:-webkit-autofill:focus": {
                                                WebkitBoxShadow: "0 0 0 1000px white inset",
                                                WebkitTextFillColor: "#0A0A0C",
                                            },
                                        },
                                    },
                                }}
                            />
                            {touched?.poValue && errors?.poValue && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors?.poValue}
                                </Typography>
                            )}
                        </Grid>
                        {/* <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Planned Delivery Date
                            </Typography>
                            <TextField
                                type="date"
                                name="plannedDeliveryDate"
                                value={values.plannedDeliveryDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onClick={(e) => {
                                    // Trigger the native date picker
                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                    if (input) input.showPicker?.();
                                }}
                                fullWidth
                                sx={{
                                    ...rightTextStyle,
                                    "& input::-webkit-calendar-picker-indicator": {
                                        display: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& input[type='date']": {
                                        appearance: "none",
                                        WebkitAppearance: "none",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            border: "none",
                                        },
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                        >
                                            {calenderSVG}
                                        </Box>
                                    ),
                                    sx: {
                                        backgroundColor: "#fff",
                                        border: '1px solid',
                                        borderColor: 'hsl(0, 0%, 80%)',
                                        height: "40px",
                                        width: { xs: "100%", md: "100%" },
                                        borderRadius: "5px",
                                    },
                                }}
                            />
                            {touched.plannedDeliveryDate && errors.plannedDeliveryDate && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors.plannedDeliveryDate}
                                </Typography>
                            )}
                        </Grid> */}
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                Select Material ProcureMent Status
                            </Typography>
                            <Autocomplete
                                options={materialProcurementStatusOption}
                                getOptionLabel={(option) => option?.label || ''}
                                value={
                                    materialProcurementStatusOption?.find(
                                        (opt) => opt.label == values?.materialProcureMentStatus
                                    ) || null
                                }
                                onChange={(_, newSelected) => {
                                    setFieldValue(
                                        `materialProcureMentStatus`,
                                        newSelected ? newSelected.label : ""
                                    );
                                }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Material Procurement Status"
                                        name={`materialProcureMentStatus`}
                                        size="small"
                                        sx={{
                                            "& input::placeholder": {
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                letterSpacing: "0.16px",
                                                color: "#5F5F5F",
                                                fontFamily: "Outfit, sans-serif",
                                                opacity: 1,
                                            },
                                        }}
                                    />
                                )}
                                ListboxProps={{ sx: { fontSize: '13px' } }}
                            />
                            {touched?.materialProcureMentStatus && errors?.materialProcureMentStatus &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.materialProcureMentStatus}`}</FormHelperText>
                            }
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                Status
                            </Typography>
                            <Autocomplete
                                options={filteredStatusOption}
                                getOptionLabel={(option) => option?.label || ''}
                                value={
                                    filteredStatusOption?.find(
                                        (opt) => opt.label == values?.status
                                    ) || null
                                }
                                onChange={(_, newSelected) => {
                                    // const updated = newSelected.map(item => ({ roleId: item?.id }));
                                    setFieldValue(
                                        `status`,
                                        newSelected ? newSelected.label : ""   // store only roleId string
                                    );
                                }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Status"
                                        name={`status`}
                                        size="small"
                                        sx={{
                                            "& input::placeholder": {
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                letterSpacing: "0.16px",
                                                color: "#5F5F5F",
                                                fontFamily: "Outfit, sans-serif",
                                                opacity: 1,
                                            },
                                        }}
                                    />
                                )}
                                ListboxProps={{ sx: { fontSize: '13px' } }}
                            />
                            {touched?.status && errors?.status &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.status}`}</FormHelperText>
                            }
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={labelTextStyle}>Material Description</Typography>
                            <TextField
                                fullWidth
                                name="materialDescription"
                                value={values.materialDescription}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                multiline
                                rows={3}
                                placeholder="Enter Material Description"
                                InputProps={{
                                    sx: {
                                        // height: "50px",
                                        borderRadius: "8px",
                                        backgroundColor: "#fff",

                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },

                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                        },
                                    },
                                }}
                            />
                            {touched.materialDescription && errors.materialDescription && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors.materialDescription}
                                </Typography>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={labelTextStyle}>Remarks / Notes</Typography>
                            <TextField
                                fullWidth
                                name="remarks"
                                value={values.remarks}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                multiline
                                rows={3}
                                placeholder="Enter Remarks / Notes"
                                InputProps={{
                                    sx: {
                                        // height: "50px",
                                        borderRadius: "8px",
                                        backgroundColor: "#fff",

                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },

                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                        },
                                    },
                                }}
                            />
                            {touched.remarks && errors.remarks && (
                                <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                    {errors.remarks}
                                </Typography>
                            )}
                        </Grid>

                        {/* <Grid size={{ xs: 12, md: 12 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Sub Project
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="subProject"
                                        value={values.subProject}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Sub Project"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "4px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#5F5F5F",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched?.subProject && errors?.subProject && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors?.subProject}
                                        </Typography>
                                    )}
                                </Grid> */}

                        <Grid size={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                }}
                            >
                                <Button onClick={handleClose}
                                    sx={{
                                        textTransform: "none",
                                        color: "#F15744",
                                        fontSize: "14px",
                                        lineHeight: "100%",
                                        fontFamily: "Outfit, sans-serif",
                                        borderRadius: "25px",
                                        fontWeight: 500,
                                        px: "20px",
                                        py: "15px",
                                    }}>
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    // loading={addActionTrackerRes?.isLoading}
                                    sx={{
                                        backgroundColor: "#00344C",
                                        borderRadius: "25px",
                                        textTransform: "none",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        lineHeight: "100%",
                                        fontFamily: "Outfit, sans-serif",
                                        color: "#FFFFFF",
                                        px: "20px",
                                        py: "15px",
                                    }}
                                >
                                    Save
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            )}
        </Formik>

    );
};

export default DpItems;
